module.exports = __webpack_public_path__ + "img/ki.a0d9f1a3.svg";